import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const LoadingContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000; /* Black background */
  display: flex;
  flex-direction: column; /* Stack text and line */
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Ensure it's on top */
`;

const NameContainer = styled(motion.div)`
    display: flex;
    overflow: hidden; /* Hide letters before they animate in */
`;

const LetterSpan = styled(motion.span)`
  color: #fff; 
  font-size: 3rem;
  font-weight: 700; // Slightly less bold
  letter-spacing: 1px; // Slightly reduced spacing
  display: inline-block; // Needed for transform animations
  margin: 0 2px; // Small space between letters

  @media (max-width: 768px) {
      font-size: 1.8rem;
      margin: 0 1px;
  }
`;

const Underline = styled(motion.div)`
    width: 0%;
    height: 2px;
    background-color: #ff0000; // Accent color underline
    margin-top: 15px;
`;

// Animation Variants
const containerVariants = {
  initial: {
    opacity: 1,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.1, // Faster container fade (already visible)
      staggerChildren: 0.08, // Stagger letter animation
      delayChildren: 0.2, // Wait slightly before starting letters
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5, 
      ease: "easeInOut"
    },
  },
};

const letterVariants = {
    initial: {
        y: "100%", // Start below view
        opacity: 0,
    },
    animate: {
        y: "0%",
        opacity: 1,
        transition: { 
            duration: 0.6, 
            ease: "easeOut"
        },
    },
};

const underlineVariants = {
    initial: {
        width: "0%",
    },
    animate: {
        width: "60%", // Animate to cover approx text width
        transition: {
            duration: 0.8,
            delay: 1.0, // Start after letters are mostly visible
            ease: "easeOut",
        },
    },
};

const LoadingScreen: React.FC = () => {
  const name = "BARKIN SAYIN";
  const letters = Array.from(name);

  return (
    <LoadingContainer
      variants={containerVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <NameContainer>
        {letters.map((letter, index) => (
          <LetterSpan 
            key={`${letter}-${index}`} 
            variants={letterVariants}
            style={{ marginRight: letter === ' ' ? '1em' : '2px' }} // Add space for space char
            >
            {letter === ' ' ? '\u00A0' : letter} {/* Non-breaking space for space */} 
          </LetterSpan>
        ))}
      </NameContainer>
      <Underline variants={underlineVariants} />
    </LoadingContainer>
  );
};

export default LoadingScreen; 